import { useEditor } from '@tiptap/react';
import { Plugin } from '@tiptap/pm/state';
import { Node, Extension } from '@tiptap/core';
import Link from '@tiptap/extension-link';
import Paragraph from '@tiptap/extension-paragraph';
import Text from '@tiptap/extension-text';
import CharacterCount from '@tiptap/extension-character-count';
import { FormEvent } from 'react';

// Replacing "Document" with a custom "Doc" to disable new lines
export const Doc = Node.create({
  name: 'Doc',
  topNode: true,
  content: 'block',
});

const ExtendedLink = Link.extend({
  name: 'editorLink',
  inclusive: false,
});

// This extension replaces new lines and breaks with spaces on paste
const PasteHandler = Extension.create({
  name: 'pasteHandler',
  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handlePaste: (view, event) => {
            event.preventDefault();
            const text = event.clipboardData?.getData('text/plain') || '';
            const formattedText = text.replace(/[\r\n]+/g, ' ');
            const { tr } = view.state;
            tr.insertText(formattedText, view.state.selection.from);
            view.dispatch(tr);
            return true;
          },
        },
      }),
    ];
  },
});

export const useTipTap = (
  changeHandler: (value: string | FormEvent<HTMLInputElement>) => void,
  defaultValue: string,
) => {
  return useEditor({
    extensions: [
      CharacterCount,
      Doc,
      Paragraph,
      Text,
      ExtendedLink.configure({
        openOnClick: false,
        // Example validation:
        // validate: (href) => /^https?:\/\//.test(href),
      }),
      PasteHandler,
    ],
    onUpdate({ editor }) {
      changeHandler(editor.getHTML());
    },
    content: defaultValue,
  });
};
